import React from 'react';
import Card from '../../components/cards/Card';
import LabeledTextInput from '../../components/inputs/LabeledTextInput';
import { Button } from '../../components';
import { Text, TouchableOpacity } from 'react-native';
import { BERRY } from '../../settings/colors';
import { useLocation, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { registerWeb } from '../../store/actions/index';
import { requestVerificationCode, verifyCode } from '../../store/actions/auth';
import AuthLayout from '../../components/layouts/AuthLayout.web';

function VerificationCode() {
  const [code, setCode] = React.useState('');
  const [error, setError] = React.useState(null);
  const [isLoading, setLoading] = React.useState(false);
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    action,
    identifier,
    firstName,
    lastName,
    birthYear,
    gender,
  } = location.state;
  const tryLogin = async () => {
    setLoading(true);
    const logInSuccessful = await dispatch(
      verifyCode({
        identifier,
        code,
      }),
    );
    setLoading(false);
    if (!logInSuccessful) {
      setError('Login fehlgeschlagen.');
    } else {
      history.push('/');
    }
  };
  const tryRegistration = async () => {
    setLoading(true);
    const registrationSuccessful = await dispatch(
      registerWeb({
        email: identifier,
        firstName,
        lastName,
        birthYear,
        gender,
        code,
      }),
    );
    setLoading(false);
    if (!registrationSuccessful) {
      return setError('Dein Konto konnte leider nicht erstellt werden.');
    }
    return history.push('/welcome');
  };
  return (
    <AuthLayout>
      <Card>
        <Text style={{ fontWeight: 'bold', fontSize: 30, textAlign: 'center' }}>
          Code eingeben
        </Text>
        {error && <Text style={{ color: 'red' }}>{error}</Text>}
        <Text
          style={{ paddingVertical: 20, textAlign: 'center', fontSize: 17 }}
        >
          {`Wir haben einen Code an ${identifier} geschickt. Es kann eine Minute
          dauern, bis du ihn erhältst.`}
        </Text>
        <LabeledTextInput
          placeholder="Code"
          value={code}
          onChangeText={newCode => setCode(newCode)}
        />
        <Button
          text="Abschicken"
          action={() =>
            action === 'registration' ? tryRegistration() : tryLogin()
          }
          size="large"
          type="primary"
          isLoading={isLoading}
        />
      </Card>
      <TouchableOpacity
        onPress={() => {
          setError(null);
          setCode('');
          dispatch(requestVerificationCode(identifier, action));
        }}
      >
        <Text style={{ color: BERRY }}>
          Kein Code erhalten? Nochmals senden.
        </Text>
      </TouchableOpacity>
    </AuthLayout>
  );
}

export default VerificationCode;
